import React from 'react';
import { useQuizContext } from '../../../../context/QuizContext';
import QuizSubmitButtons from '../../QuizSubmitButtons';
import { SkipQuizButton } from '../utils';

type Props = unknown; //todo

/**
 * Https://elsevier.atlassian.net/browse/OSMS-2005.
 */

/**
 * LabelMatching.
 */
const LabelMatching = (props: Props) => {
  const { currentIndex } = useQuizContext();
  return (
    <div>
      {
        // eslint-disable-next-line formatjs/no-literal-string-in-jsx
        'LabelMatching Placeholder'
      }
      <QuizSubmitButtons submit={() => currentIndex % 2 === 0} />
      <SkipQuizButton />
    </div>
  );
};

export default LabelMatching;
